module.exports = __webpack_public_path__ + "media/images/osm-banner-df28fec8ca28f5dd138a31e48bc4677c.jpg";